var map = {
	"./ar.json": [
		"L1NN",
		0
	],
	"./en.json": [
		"amrp",
		1
	],
	"./fr.json": [
		"b3ex",
		2
	],
	"./tr.json": [
		"Uusv",
		3
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "5ey7";
module.exports = webpackAsyncContext;